/**
 * Ce que la route de la regie En direct (`routes.tsx`) lit sans charger l'ecran : son adresse et les phrases d'attente et
 * d'echec. L'ecran (`en-direct.tsx` et ses panneaux) est livre a part, comme celui de la diffusion : tant que `routes.tsx` le
 * charge par `import()`, rien de `direct/en-direct*.tsx` ne doit etre importe a la lecture depuis le paquet d'entree
 * (`routes.test.tsx` le verifie).
 */

/** Le temps que l'ecran se charge. */
export const EN_DIRECT_CHARGEMENT = "Chargement de la régie...";

/** Quand son chargement echoue (l'app a ete mise a jour depuis l'ouverture de l'onglet, le plus souvent). */
export const EN_DIRECT_INDISPONIBLE =
  "La régie n'a pas pu être chargée. Recharge la page : Castellan a peut-être été mis à jour depuis l'ouverture de cet onglet.";

/** La page de la fiche d'un viewer, au telephone. */
export const VIEWER_PATH = "/regie/viewers";
